import Debouncer from '../../lib/Debouncer';

export interface ScrolledConfig {
	scrolledClass: string;
	scrolledDistanceClass: string;
	scrollDistanceDown: number;
	scrollDistanceUp: number;
}

/**
 * Adds config.scrolledClass to body if the page has been scrolled,
 * adds config.scrolledDistanceClass to body when scrolled down
 * by config.scrollDistanceDown and removes the same class when
 * scrolled back up by config.scrollDistanceUp
 */
export default class Scrolled {
	constructor(private config: ScrolledConfig) {
		const viewport: HTMLElement = document.querySelector('.viewport');

		// let triggerPoint: number = window.pageYOffset;
		let triggerPoint: number = viewport.scrollTop;

		const scrollDebouncer = new Debouncer(() => {
			if (config.scrolledClass !== undefined) {
				// if (window.pageYOffset > 0) {
				if (viewport.scrollTop > 0) {
					// document.body.classList.add(config.scrolledClass);
					viewport.classList.add(config.scrolledClass);
				} else {
					// document.body.classList.remove(config.scrolledClass);
					viewport.classList.remove(config.scrolledClass);
				}
			}

			if (config.scrolledDistanceClass !== undefined) {
				// const diff = window.pageYOffset - triggerPoint;
				const diff = viewport.scrollTop - triggerPoint;
				
				if (diff > 0 && diff >= config.scrollDistanceDown) {
					// Scroll down

					// triggerPoint = window.pageYOffset;
					triggerPoint = viewport.scrollTop;

					// document.body.classList.add(config.scrolledDistanceClass);
					viewport.classList.add(config.scrolledDistanceClass);
				} else if (diff < 0 && 0 - diff >= config.scrollDistanceUp) {
					// Scroll up

					// triggerPoint = window.pageYOffset;
					triggerPoint = viewport.scrollTop;

					// document.body.classList.remove(config.scrolledDistanceClass);
					viewport.classList.remove(config.scrolledDistanceClass);
				}
			}
		});
		// window.addEventListener('scroll', scrollDebouncer.run);
		viewport.addEventListener('scroll', scrollDebouncer.run);
		scrollDebouncer.runNow();
	}
}